export function obterListaTipoArmamento() {
  return (
    [
      { label: '0 - Uso Permitido', value: 'PERMITIDO' },
      { label: '1 - Uso Restrito', value: 'RESTRITO' },
    ]
  );
}
